module.exports = __webpack_public_path__ + "img/filter-square.ee564fef.svg";